import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private History Types */
import {
  _History
} from '../namespace-helper'

export default {
  namespaced: true,
  state: {
    histories: []
  },
  mutations: {
    [_History.mutations.setHistories] (state, payload) {
      state.histories = payload
    }
  },
  actions: {
    [_History.actions.saveHistory] (context, payload) {
      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/histories'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_History.actions.loadHistories] (context, payload) {
      console.log('loadHistories: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/histories/' + payload.histories_types_id + '/' + payload.id

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          console.log('loadHistories: ' + JSON.stringify(r.data.data))
          context.commit(_History.mutations.setHistories, r.data.data)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_History.actions.resetState] (context, payload) {
      context.commit(_History.mutations.setHistories, [])
    }

  },
  getters: {
    [_History.getters.histories] (state) {
      return state.histories
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/History/histories.js